// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Header_Wrapper__11seI","Title":"Header_Title__2e41c","Nav":"Header_Nav__1PA9Y","Logo":"Header_Logo__3TQJS","Links":"Header_Links__1ysVF"};